<template>
  <v-container style="width: 800px;">
    <v-card>
      <v-container>
        <v-card-title class="title-highlight">
          {{ $t('title.admin-select-store') }}
        </v-card-title>

        <v-data-table
          :headers="storeHeaders"
          :items="dispSelectedStores"
          class="elevation-1"
          hide-actions
          :loading="loadingData"
        >
          <template v-slot:items="props">
            <tr>              
              <td class="text-xs-left">{{ props.item.storeCode }}</td>
              <td class="text-xs-left">{{ props.item.storeName }}</td>
              <td class="text-xs-left">{{ props.item.supplierCode }}</td>
            </tr>
          </template>         
        </v-data-table>

        <div style="height: 55px;"></div>
      </v-container>
    </v-card>

    <div style="height: 55px;"></div>
    <v-card>
      <v-container>
        <v-card-title class="title-highlight">
          {{ $t('title.admin-store-item-list') }}
        </v-card-title>

        <!-- 점포 검색조건 -->
        <v-layout row span justify-space-between>
          <v-flex sm4>
            <v-select
              v-model="selectCategory"
              :items="itemCategories"
              label="商品カテゴリ"
              item-text="itemCategoryName"
              item-value="itemCategoryId"
              :sort-by="['itemCategoryId']"
              :sort-desc="[false]"
              return-object
              style="width: 100%;"
            ></v-select>
          </v-flex>
        </v-layout>

        <div style="
          white-space: pre-line;
          margin-bottom: 10px;
          text-align: left;
        ">※選択店舗数が1の場合、当該店舗に登録されている非表示商品をチェック済み(操作不可)として表示する。<br>※選択店舗数が複数の場合、全商品を表示する。
        </div>

        <!-- 전체선택 -->
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <v-checkbox
            v-model="allSelected"
            @change="toggleAll"
            hide-details
            primary
            dense
            label="全選択/解除"
            class="same-font"
          ></v-checkbox>
        </div>

        <!-- 상품 데이타 -->
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          hide-actions
          :customFilter="customFilter"
          :search="selectCategory"
        > 
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.header.text }}</span>
              </template>
              <span>{{ props.header.text }}</span>
            </v-tooltip>
          </template>
          
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left" style="width: 30px;" @click="itemCheck(props.item)">
                <v-checkbox 
                  v-model="props.item.isHandling" 
                  :disabled="props.item.isLocked" 
                  primary 
                  hide-details>
                </v-checkbox>
              </td>
              <td class="text-xs-left">{{ props.item.itemCategoryName }}</td>
              <td class="text-xs-left">{{ props.item.itemName }}</td>
              <td class="text-xs-left">{{ props.item.janCode }}</td>
              <td class="text-xs-right">{{ Number(props.item.unitPrice || 0).toLocaleString() }}</td>
            </tr>
          </template>
        </v-data-table>
        
        <div style="height: 25px;"></div>

        <!-- 버튼 영역 -->
        <div class="footer-btns">
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/display-store-items-list2' }">
            <v-icon dark left>arrow_back</v-icon>{{ $t('back-btn') }}
          </v-btn>
          <v-btn block class="ma-2" color="success" @click="updateDisplayStoreItems()">
            <v-icon dark left>save</v-icon>非表示に登録する
          </v-btn>          
        </div>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import { mapState } from 'vuex'

Vue.use(VeeValidate)

export default {
  $_veeValidate: {
    validator: 'new'
  },
  created() {
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    // 세션에서 점포정보 가져오기
    const params = JSON.parse(sessionStorage.getItem("param"));    
    for (let i=0; i<params.length; i++) {
      this.dispSelectedStores.push(params[i]);
    }

    // 모든 카테고리 정보 가져오기
    ServerApiCallService.itemCategories()
      .then(response => {
        console.log('completed item categories')

        this.itemCategories = response.data.itemCategories
        this.itemCategories.unshift({
          itemCategoryId: '#',
          itemCategoryName: '全て'
        })
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })

    // 모든 상품 가져오기
    ServerApiCallService.displayStoreItems2()
    .then(response => {
      console.log('completed display items')
      this.items = response.data.items
      
      let nonDisplayItems
      // 상품코드가 하나인 경우
      // 서버에 이미 ‘비표시(Non-display)’로 등록된 상품”을 받아와서, 화면에 있는 this.items 목록에서 해당 상품들을 자동으로 체크/선택 상태로 만들고, 수정 못 하게 잠근다.
      if (params.length == 1) {
        // 비표시 등록 상품만 가져오기
        let storesRequest = { storeCode: params[0].storeCode }
        ServerApiCallService.nonDisplayStoreItems(storesRequest)
          .then(response => {        
            nonDisplayItems = response.data.items

            // 비 표시 상품코드를 set에 넣는다
            const codeSet = new Set(nonDisplayItems.map(x => String(x.itemCode).trim()));
            
            // 화면에 있는 전체 상품(this.items)을 돌면서 “비표시 등록 여부”를 체크한다
            this.items.forEach(item => {
              const code = String(item.itemCode).trim();
              if (codeSet.has(code)) {
                item.isChecked = true;
                item.isHandling = true;
                // 이미 등록되어 있어 수정 못하게 잠금
                item.isLocked = true;

                this.selectedItems.push(item);  
              } else {                 
                // 비표시 등록된 상품이 아니면: 초기값 세팅(널일 때만)
                if (item.isLocked == null) item.isLocked = false;
                if (item.isChecked == null) item.isChecked = false;
                if (item.isHandling == null) item.isHandling = false;
              }
            });
          })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
      }
      
    })
    .catch(error => {
      console.log('There was an error:', error.response)
    })
  },
  methods: {
    // 전체선택, 전체해제 UI용 기능
    toggleAll() {
      let checked = this.allSelected;

      // 화면에 보이는 상품만 처리
      this.items.forEach(item => {
        if (item.isLocked) return; // 잠금은 제외

        item.isChecked = checked;
        item.isHandling = checked;
      });

      // selectedItems 동기화: 잠금된 기존 등록은 항상 포함 + 신규 선택만 반영
      const locked = this.items.filter(x => x.isLocked);
      const newly = checked ? this.items.filter(x => !x.isLocked) : [];

      this.selectedItems = [...locked, ...newly];
    },
    itemCheck(itemInfo) {
      if (itemInfo.isLocked) return; // 기존 등록 상품은 수정 불가

      this.loading2 = false

      if (itemInfo.isChecked) {
        itemInfo.isChecked = false

        // 체크를 지웠을때 
        for(let i = 0; i < this.selectedItems.length; i++) {
          if(this.selectedItems[i].itemCode === itemInfo.itemCode)  {
            this.selectedItems.splice(i, 1);
            if (i > 0) i--;
          }
        }
      } else {
        // 체크를 했을때
        itemInfo.isChecked= true;
        this.selectedItems.push(itemInfo);
      }

      // 전체 체크박스 체크/비체크
      if (this.selectedItems.length == this.items.length) {
        this.allSelected = true
      } else {
        this.allSelected = false
      }
    },
    customFilter(items, search) {
      if (search.itemCategoryName === '全て') {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemCategoryId === search.itemCategoryId) {
            return true
          } else {
            return false
          }
        })

        return filteringItems
      }
    },
    async updateDisplayStoreItems() {      
      this.loading2 = true

      // 신규로 선택된 상품만 추리기 (기존 등록/잠금은 제외)
      const newSelectedItems = (this.selectedItems || []).filter(x => !x.isLocked);

      // 신규 선택이 0개면 막기
      if (newSelectedItems.length < 1) {
        this.loading2 = false; // 로딩 원복 꼭!
        this.$parent.$parent.$parent.showErrorDialog('商品を選択してください');
        return;
      }
      
      // 선택된 복수의 점포를 수정해서 재 보관
      let selectedShops = [];
      this.dispSelectedStores.forEach((dispStore) => {
        delete dispStore.isChecked
        selectedShops.push(dispStore)
      })

      let request = [];
      let obj = {
        stores: selectedShops,
        items: this.selectedItems
      }

      request.push(obj);
      
      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/display-store-items-list2'
      }


      // 점포에 상품을 추가
      ServerApiCallService.displayStoreItemsUpdate2(
          request,
          sendContext
        ).then(() => {
          this.loading2 = false
        }).catch(error => {
          console.log('There was an error:', error.response)
        })
    },    
  },
  computed: {
    ...mapState({
      user: state => state.admin
    }),
    selectCategory: {
      get() {
        return this.$store.state.adminSession.selectCategory
      },
      set(value) {
        this.$store.commit('SET_SELECTED_ITEM_CATEGORY', value)
      }
    }
  },
  data() {
    return {
      loadingData: false,
      isHandling: true,
      loading: true,
      loading2: false,
      checkbox: null,
      storeName: '',      
      storeCode: this.$route.params.storeCode,
      allSelected: false,

      items: [],
      selected: [],
      itemCategories: [],
      shopsItems: [],
      dispSelectedStores: [], // 선택되어져 넘어온 점포
      allStores: [], // 모든 점포
      selectedItems: [], // 선택한 상품

      multipleSearchObj: {
        itemCategoryId: '#',
        dispOnlyHandling: false
      },

      headers: [
        {
          text: '選択',
          align: 'left',
          sortable: false,
          value: 'selectSupplier',
          width: '30px',
          fixed: true
        },
        {
          text: 'カテゴリ',
          align: 'left',
          value: 'itemCategoryName',
          width: '120px',
          sortable: false
        },
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          width: '200px',
          sortable: false
        },
        {
          text: 'JANコード',
          align: 'left',
          value: 'janCode',
          width: '30px',
          sortable: false
        },
        {
          text: '単価',
          align: 'center',
          value: 'unitPrice',
          width: '30px',
          sortable: false
        },
      ],
      storeHeaders: [        
        {
          text: '店舗コード',
          align: 'left',
          value: 'storeCode',
          width: '150px',
          sortable: false
        },
        {
          text: '店舗名',
          align: 'left',
          value: 'storeName',
          width: '350px',
          sortable: false
        },
        {
          text: '取引先コード',
          align: 'left',
          value: 'supplierCode',
          width: '150px',
          sortable: false
        },
      ],
    }
  }
}
</script>

<style>
.same-font .v-label {
  font-size: 14px !important;     /* テーブルと同じ文字サイズ */
  font-weight: normal !important; /* テーブルの通常文字と同じ */
  color: #2c3e50 !important;      /* テーブル文字 색상과 일치 */
}
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>